package com.vizio.redwolf.utils

data class ConsentV2ProxyEnvironmentConfig(val environmentGroup: EnvironmentGroup)